




















// Copyright © 2021 Move Closer

import { defineComponent } from '@vue/composition-api'

import { DashmixIcon, DashmixIconName } from '../../../atoms/Icon'

/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const DashmixModalInner = defineComponent({
  name: 'ModalInner',
  components: { DashmixIcon },
  props: {
    noControl: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['close'],

  setup () {
    return { Icons: DashmixIconName }
  }
})

export default DashmixModalInner
